export default __webpack_public_path__ + "static/media/garage-top.c890eef4.gif";